<div class="modal-header">
  <h4 class="modal-title">Ventana Modal</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <h3>Aqui va el contenido de la ventana modal</h3>
    <div class="modal-footer full-width col-md-12">
      <div class="col-md-12">
        <button type="button" class="btn btn-danger col-md-6" (click)="dismiss()">
          <i class="fa fa-times-circle"></i>
          Cancelar
        </button>
        <button type="button" class="btn btn-success col-md-6" (click)="close()">
          <i class="fa fa-check-circle"></i>
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>
